import React, { useState } from 'react';

function DataTable({ columns, data, emptyMessage, emptyIcon, onRowClick, rowClassName, loading, skeletonRows = 5 }) {
  const [sortCol, setSortCol] = useState(null);
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (col) => {
    if (!col.sortable) return;
    const key = col.key;
    if (sortCol === key) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    } else {
      setSortCol(key);
      setSortDir('asc');
    }
  };

  let rows = data || [];
  if (sortCol) {
    const col = columns.find(c => c.key === sortCol);
    rows = [...rows].sort((a, b) => {
      const av = col.sortValue ? col.sortValue(a) : a[sortCol];
      const bv = col.sortValue ? col.sortValue(b) : b[sortCol];
      if (av == null) return 1;
      if (bv == null) return -1;
      const cmp = typeof av === 'string' ? av.localeCompare(bv) : av - bv;
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }

  if (loading) {
    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>{columns.map(c => <th key={c.key}>{c.header}</th>)}</tr>
          </thead>
          <tbody>
            {Array.from({ length: skeletonRows }, (_, i) => (
              <tr key={i}>
                {columns.map(c => (
                  <td key={c.key}><div className="admin-skeleton" style={{ height: '14px', borderRadius: '4px', width: `${60 + Math.random() * 40}%` }} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map(c => (
              <th
                key={c.key}
                onClick={() => handleSort(c)}
                style={{
                  cursor: c.sortable ? 'pointer' : 'default',
                  userSelect: c.sortable ? 'none' : 'auto',
                  ...(c.width ? { width: c.width } : {}),
                  ...(c.headerStyle || {}),
                }}
              >
                {c.header}
                {c.sortable && sortCol === c.key && (
                  <i className={`fa-solid fa-sort-${sortDir === 'asc' ? 'up' : 'down'}`} style={{ marginLeft: '4px', fontSize: '10px' }} />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="admin-table-empty">
                {emptyIcon && <div style={{ fontSize: '24px', marginBottom: '8px', opacity: 0.4 }}><i className={emptyIcon} /></div>}
                {emptyMessage || 'No data found'}
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr
                key={row.id || row.key || idx}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                style={onRowClick ? { cursor: 'pointer' } : undefined}
                className={rowClassName ? rowClassName(row) : undefined}
              >
                {columns.map(c => (
                  <td key={c.key} style={c.cellStyle || undefined}>
                    {c.render ? c.render(row, idx) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
